import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, NewButton, SaveButton } from "../../../components/Buttons";

export const Inventory = () => {
    document.title = "İnventarizasiya";
    
    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "İnventarizasiya", value: "/products/move", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">İnventarizasiya</h2>
                    <p>
                        İnventarizasiya , anbar sayımı zamanı real say ilə düzəliş üçün nəzərdə tutulub. <NewButton>Yeni inventarizasiya</NewButton> düyməsini
                        sıxıb açılan sənəddə sayım olunacaq anbarı seçib, <Button>Anbar qalığı</Button> düyməsi ilə məhsulları əlavə etmək olar. Seçilmiş
                        məhsullar inventarizasiya səhifəsinə avtomatik əlavə olunacaq. Faktiki say qeyd olunduqdan sonra <SaveButton /> düyməsini sıxmaq
                        lazımdır. İnventarizasiya sənədi yadda saxlanıldıqdan sonra <Button>Sənəd yarat</Button> düyməsi ilə <Button>Daxilolma</Button>
                        və ya <Button>Silinmə</Button> əməliyyatı icra olunur.
                        <br />
                        <b>Qeyd</b>: <Link to={"/products/enter"}>Daxilolma</Link> və <Link to={"/products/loss"}>Silinmə</Link> sənədinə keçid olduqda,
                        məhsulların fərqi avtomatik olaraq Daxilolma və Silinmə sənədinə yerləşdirilir.
                        <br />
                        <b>Qeyd</b>: İnventarizasiya sənədi heç bir halda məhsulların anbar qalığına təsir etmir.
                    </p>
                    <img src="/images/products/documents/inventory.gif" alt="İnventarizasiya" />
                </article>
            </div>
        </div>
    );
};
